import axios from 'axios';
import {BaseResponse} from "../../BaseResponse";
import {VolumeList} from "./getVolumeList";

export async function putVolumeList(request: VolumeList) {
    const response = await axios.put<BaseResponse<boolean>>(`/basic/volume_price`, request)
    return response.data
}